class ProductItemVideo extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      video: "[js-video]",
    };

    this.attrs = {
      hoverPlay: "data-hover-play",
    };

    this.classes = {};
  }

  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };

    this.video = this.querySelector(this.selectors.video);
    this.hoverPlay = this.getAttribute(this.attrs.hoverPlay) === "true";

    if (this.hoverPlay) {
      this.addEventListener(
        "mouseenter",
        e => this._handleHover(e),
        this.eventOptions
      );
      this.addEventListener(
        "focusin",
        e => this._handleHover(e),
        this.eventOptions
      );
      this.addEventListener(
        "mouseleave",
        e => this._handleHover(e),
        this.eventOptions
      );
      this.addEventListener(
        "focusout",
        e => this._handleHover(e),
        this.eventOptions
      );
    }
  }

  _handleHover(e) {
    switch (e.type) {
      case "mouseenter":
      case "focusin":
        clearTimeout(this.videoTimeout);
        this.videoTimeout = setTimeout(() => this._playVideo(), 250);
        break;

      case "mouseleave":
      case "focusout":
        clearTimeout(this.videoTimeout);
        this._pauseVideo();
        break;
    }
  }

  _playVideo() {
    this.video.play();
  }

  _pauseVideo() {
    this.video.pause();
  }

  disconnectedCallback() {
    this.eventController.abort();
  }
}

if (!customElements.get("product-item-video")) {
  customElements.define("product-item-video", ProductItemVideo);
}
